// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import RestaurantTagsList from '../../constants/RestaurantTagsList';

// -- views
import LocalizableSelect from './LocalizableSelect';

class RestaurantTagChooser extends Component {

  static defaultProps = {
    tag: ''
  };

  static propTypes = {
    tag: PropTypes.string,

    /**
     * @param String
     */
    onChange: PropTypes.func.isRequired
  };

  onChange = (selection) => {
    if (_.isNull(selection)) {
      this.props.onChange(null);
    } else {
      this.props.onChange(selection.value);
    }
  };

  render() {
    const options = RestaurantTagsList.getTagsListForPicker();

    return (
      <div className="restaurant_tag_chooser">
        <LocalizableSelect
          name="action"
          value={this.props.tag}
          options={options}
          onChange={this.onChange}
          readOnly={this.props.readOnly}
        />
      </div>
    );
  }

}

export default RestaurantTagChooser;
